/* SKILLS TYPES */
export const SKILL_PARENT = "SKG";
export const SKILL_CHILD = "SKL";